exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".customer-layout {\n  background: #e9e8e8; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/layouts/CustomerLayout/CustomerLayout.scss
// module id = 1510
// module chunks = 0